import { useEffect, useRef, useState } from 'react';

const portalFaqs = [
  {
    question: 'How do I start my exam?',
    answer: 'Click Setup Exam first if optional sections are available. Once your setup is complete and the exam window is active, click Start Exam to begin.',
  },
  {
    question: 'Why is the Start Exam button disabled?',
    answer: 'The exam may not be available yet, the exam window may have ended, or your setup may still be pending. Check the scheduled time shown on the portal.',
  },
  {
    question: 'Will my answers be saved automatically?',
    answer: 'Yes. Your responses are saved during the test, but you should still avoid refreshing the page or closing the browser tab during the exam.',
  },
  {
    question: 'Can I choose optional sections?',
    answer: 'Yes, if your recruiter configured optional sections. Use Setup Exam to select the sections allowed for your assessment before starting.',
  },
  {
    question: 'When can I see my result?',
    answer: 'Your result becomes visible only after the recruiter publishes it. Once published, the portal will let you open the result page directly.',
  },
  {
    question: 'What should I do if I face an issue during the exam?',
    answer: 'Keep your internet stable, avoid switching tabs, and contact your recruiter or exam coordinator immediately if the issue continues.',
  },
];

export default function PortalFaqHelp() {
  const [showFaq, setShowFaq] = useState(false);
  const faqRef = useRef(null);

  useEffect(() => {
    if (!showFaq) return undefined;

    const handleOutsideClick = (event) => {
      if (faqRef.current && !faqRef.current.contains(event.target)) {
        setShowFaq(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [showFaq]);

  return (
    <div className="dash-help-wrap" ref={faqRef}>
      <button
        className={`dash-icon-btn${showFaq ? ' dash-icon-btn--active' : ''}`}
        aria-label="Help"
        aria-expanded={showFaq}
        onClick={() => setShowFaq((current) => !current)}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </button>

      {showFaq && (
        <div className="dash-faq-popover">
          <div className="dash-faq-header">
            <span>Portal FAQ</span>
            <button type="button" onClick={() => setShowFaq(false)} aria-label="Close FAQ">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <div className="dash-faq-list">
            {portalFaqs.map((item) => (
              <div key={item.question} className="dash-faq-item">
                <h4>{item.question}</h4>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
